/* Determines the effective end date for an event schedule */
export default function (schedule, startDate) {
  const {recurrenceEndDate, recurrenceCount, daysOfWeek} = schedule;
  if (recurrenceEndDate) {
    return recurrenceEndDate;
  } else if (recurrenceCount && daysOfWeek.size > 0) {
    let start = startDate.clone().set(schedule.time.toJS());
    let meetingCount = 0;
    while (meetingCount < recurrenceCount) {
      start = nextAvailableDate(schedule, start);
      meetingCount++;
    }
    return start;
  }
}

/**
 * Get the date and time for the next review after the given date.
 *
 * This mirrors the kotlin code in the scheduler, but ignores timezones.
 *
 * @param schedule {EventSchedule} the schedule.
 * @param after {Moment} date to start looking for the next available date.
 */
function nextAvailableDate(schedule, after) {
  const {time, daysOfWeek, weeksBetween} = schedule;
  const afterAtTime = after.clone().set(time.toJS());
  const working = afterAtTime.clone();
  // The scheduler adjusts the start time forward by 12 hours to avoid scheduling reviews
  // right away. Take account of that here.
  working.add(12, 'hour');
  // Too close to start today. Add a day.
  if (cmpTime(working, afterAtTime) > 0) {
    working.add(1, 'day');
  }
  while (!daysOfWeek.includes(working.format('dddd'))) {
    if (working.format('dddd') === 'Sunday') {
      working.add(weeksBetween - 1, 'week');
    }
    working.add(1, 'day');
  }
  return working;
}

/**
 * Compare the time of two moments.
 * @param a {Moment}.
 * @param b {Moment}.
 * @return 0 if the time of a is the same as b, -1 if less, 1 if greater.
 */
function cmpTime(a, b) {
  const aSeconds = secondsOfDay(a);
  const bSeconds = secondsOfDay(b);
  return aSeconds === bSeconds ? 0 : aSeconds < bSeconds ? -1 : 1;
}

/**
 * Get the time of day, in seconds.
 * @param moment {Moment}.
 */
function secondsOfDay(moment) {
  return moment.hour() * 3600 + moment.minute() * 60 + moment.second();
}
